import { Instagram, Mail } from "lucide-react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import PageShell from "../components/marketing/PageShell";
import PageHero from "../components/marketing/PageHero";
import ContactForm from "../components/marketing/ContactForm";

export default function ContactPage() {
  return (
    <PageShell testid="page-contact">
      <SEO
        title="Contact"
        description="Get in touch with the BRep team — for coach applications, press, partnerships, and general enquiries."
        path="/contact"
      />
      <Nav />
      <PageHero
        eyebrow="Contact"
        title="Say"
        titleAccent="hello."
        subtitle="Coach applications, partnerships, press, or just a question — drop us a line."
      />
      <section className="px-6 md:px-12 py-16 md:py-24">
        <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#2A5BFF] mb-4">Direct</div>
            <h2 className="font-anton uppercase text-4xl md:text-5xl leading-[0.95]">
              Prefer email?
            </h2>
            <p className="mt-4 text-white/60 max-w-md">
              We reply to every message within 48 hours.
            </p>

            <div className="mt-10 space-y-4 text-sm">
              <a
                href="mailto:hello@thebrep.app"
                className="flex items-center gap-3 text-white/70 hover:text-[#2A5BFF] transition-colors"
                data-testid="contact-email-link"
              >
                <Mail size={18} />
                hello@thebrep.app
              </a>
              <a
                href="#"
                className="flex items-center gap-3 text-white/70 hover:text-[#2A5BFF] transition-colors"
                data-testid="contact-instagram-link"
              >
                <Instagram size={18} />
                Instagram
              </a>
            </div>

            <div className="mt-12 border-t border-white/10 pt-8">
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/40">Powered by</div>
              <div className="text-[12px] tracking-[0.28em] uppercase text-[#2A5BFF] font-medium mt-1">
                Byron Performance Coaching
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </section>
      <Footer />
    </PageShell>
  );
}
